
const FurtherActions = {
  NoFurtherActions: 'NOFURTHERACTIONS',
  AccountInactive: 'INACTIVE',
  EmailNotValidated: 'EMAILNOTVALIDATED',
};
export default FurtherActions;
